import React from "react";
import {
  Box,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  ListItemButton,
  ListItem,
} from "@common-ui/ui";

import { FixedSizeList } from "react-window";

export const ListViewCustomer = ({ data, setSelection }) => {
  const renderRow = ({ index, style }) => {
    const item = data[index];
    return (
      <>
        <ListItem
          key={index}
          style={style}
          component="div"
          sx={{ paddingLeft: 0 }}
        >
          <ListItemButton
            // disablePadding
            divider={true}
            onClick={() => setSelection(item)}
          >
            <ListItemAvatar>
              <Avatar
                variant="rounded"
                alt={item.name}
                src={`https://avatars.dicebear.com/v2/initials/${item.name}.svg?chars=2`}
              />
            </ListItemAvatar>
            <ListItemText
              primary={item.name}
              secondary={
                item.system_id ? (
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      Account Number: {item.account || "None"} | Phone:{" "}
                      {item.phone || "None"}
                    </Typography>{" "}
                    - Notes: {item.notes || "None"}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      ID: {item.id || "None"} | Phone: {item.phone || "None"}
                    </Typography>
                  </React.Fragment>
                )
              }
            />
          </ListItemButton>
        </ListItem>
        {/* {index !== data.length ? <Divider sx={{ my: 2 }} /> : ""} */}
      </>
    );
  };
  return (
    <>
      <Box
        component="main"
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: 400,
          bgcolor: "background.paper",
        }}
      >
        <FixedSizeList
          height={400}
          itemCount={data.length}
          itemSize={70}
          overscanCount={5}
        >
          {renderRow}
        </FixedSizeList>
      </Box>
    </>
  );
};
